
type BrandData = {
  [key: string]: { total: number; failed: number };
};

type Props = {
  brandData: BrandData;
};

export default function BrandAnalysis({ brandData }: Props) {
  // Guard against unexpected non‑object input
  if (!brandData || typeof brandData !== "object") {
    console.error("BrandAnalysis: Invalid brandData prop");
    return null;
  }

  const sorted = Object.entries(brandData).sort(
    (a, b) => b[1].total - a[1].total
  );

  if (sorted.length === 0) {
    return (
      <div className="bg-white rounded-xl shadow-sm p-6">
        <h3 className="text-base font-bold text-gray-900 mb-4 flex items-center gap-2">
          <i className="ri-bar-chart-box-line text-teal-600"></i>
          Marka Analizi
        </h3>
        <p className="text-gray-500 text-center py-6 text-sm">
          Henüz veri yok
        </p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl shadow-sm p-6">
      <h3 className="text-base font-bold text-gray-900 mb-5 flex items-center gap-2">
        <i className="ri-bar-chart-box-line text-teal-600"></i>
        Marka Bazlı Analiz
      </h3>
      <div className="space-y-4">
        {sorted.map(([brand, data]) => {
          // Prevent division by zero
          const successRate =
            data.total > 0
              ? ((data.total - data.failed) / data.total) * 100
              : 0;

          const roundedRate = Math.round(successRate);

          // Determine colour classes once for readability
          const rateColorClass =
            roundedRate >= 90
              ? "text-green-600 bg-green-500"
              : roundedRate >= 70
              ? "text-amber-600 bg-amber-500"
              : "text-red-600 bg-red-500";

          return (
            <div key={brand}>
              <div className="flex items-center justify-between mb-1.5">
                <span className="text-sm font-medium text-gray-900">
                  {brand}
                </span>
                <div className="flex items-center gap-3 text-xs text-gray-500">
                  <span>{data.total} toplam</span>
                  <span className="text-red-500">{data.failed} fail</span>
                  <span className={`font-semibold ${rateColorClass}`}>
                    {roundedRate}%
                  </span>
                </div>
              </div>
              <div className="w-full bg-gray-100 rounded-full h-2">
                <div
                  className={`h-2 rounded-full transition-all ${rateColorClass.split(
                    " "
                  )[1]}`}
                  style={{ width: `${roundedRate}%` }}
                ></div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
